import * as types from '../../mutation-types'
import * as api from '../../api'

const state = {
  zone_exceptions: []
}

const getters = {
  allZoneExceptions: state => state.zone_exceptions
}

const actions = {
  getZoneExceptions ({ commit }) {
    api.instance.get('zone_exceptions')
      .then(function (response) {
        const zoneExceptions = response.data.zone_exceptions
        commit(types.RECEIVE_ZONE_EXCEPTIONS, zoneExceptions)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  addZoneException ({ commit }, zoneId) {
    api.instance.post('zone_exceptions', { zone_id: zoneId })
      .then(function (response) {
        const zoneException = response.data.zone_exception[0]
        commit(types.ADD_ZONE_EXCEPTION, zoneException)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  deleteZoneException ({ commit }, zoneExeption) {
    api.instance.delete('zone_exceptions/' + zoneExeption.zone_exception_id)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.DELETE_ZONE_EXCEPTION, zoneExeption)
        }
      })
  }
}

const mutations = {
  [types.RECEIVE_ZONE_EXCEPTIONS] (state, zoneExceptions) {
    state.zone_exceptions = zoneExceptions
  },
  [types.ADD_ZONE_EXCEPTION] (state, zoneException) {
    state.zone_exceptions.push(zoneException)
  },
  [types.DELETE_ZONE_EXCEPTION] (state, zoneException) {
    let zoneExceptionToDelete = state.zone_exceptions.find(
      function (ele) {
        if (ele.zone_exception_id === zoneException.zone_exception_id) {
          return true
        }
      }
    )
    let index = state.zone_exceptions.indexOf(zoneExceptionToDelete)
    state.zone_exceptions.splice(index, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
